module.exports = __webpack_public_path__ + "static/media/upload-desktop.8ebcad28.svg";